<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >
           
            <scroll-area>
              <template slot="header">

                <v-toolbar class="active" :height="44" flat dark>
                  <v-toolbar-title>
                    <span class="body-2 uppercase blacktext--text">{{ $t('users') }}</span>
                  </v-toolbar-title>

                  <v-layout fill-height justify-end align-center>

                    <v-tooltip dark color="secondary" bottom>
                      <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__btn__' + 'onAdd'" 
                      @click="() => onAdd()">
                        <svg-icon
                          :color="'whblacktextite'"
                          :name="'add'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('add') }}</span>
                    </v-tooltip>

                    <!-- <v-tooltip v-if="!edit" dark color="secondary" bottom>
                      <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__btn__' + 'edit'" 
                      @click="() => {edit = !edit}">
                        <svg-icon
                          :color="'blacktext'"
                          :name="'edit'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('edit') }}</span>
                    </v-tooltip> -->

                    <!-- <v-tooltip v-if="edit" dark color="secondary" bottom>
                      <v-btn icon flat slot="activator"  
                      :data-testid="$options.name + '__btn__' + 'close'" 
                      @click="() => {edit = !edit}">
                        <svg-icon
                          :color="'blacktext'"
                          :name="'close'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('close') }}</span>
                    </v-tooltip> -->

                  </v-layout>

                </v-toolbar>

              </template>

              <template slot="body">

                <v-layout column fill-height justify-start ma-0 pa-0 >

                  <scroll-table
                    :data="getTable"
                    :options="getOptions"
                    :sortable="true"
                    :sorted="sort"
                    :subscribed="false"
                    :headUppercase="false"
                    :translate="true"
                    :hideValues= "['undefined', 'null']"
                    @select=""
                    @value="(payload)=>onSelect(payload)"
                    @sort="(item) => sortTable(item)"
                  />

                </v-layout>

              </template>

            </scroll-area>
          </v-layout>

        </v-flex>
        
      </v-layout>

    </v-layout>

    <v-dialog persistent v-model="dialog.open" max-width="1000px" v-if="dialog.open">
      <user-card
        :data="getDialogData"
        :addMode="getAddMode"
        :parentData="getData"
        @update="(payload) => onUpdate(payload)"
        @add="(payload) => onCreate(payload)"
        @remove="(payload) => onRemove(payload)"
        @close="() => onDialogClose()"
      />
    </v-dialog>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import userCard from '@/nms/pages/configuration/components/user-card.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface DialogState {
  open: boolean
  addMode: boolean
  data: any | null
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
  noTranslate?: boolean
}

interface TableRow {
  name?: string
  id?: string
  type_auth?: string
  role?: string
  email?: string
  sms_phone?: string
  $id?: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface UserData {
  $id?: string
  name?: string
  [key: string]: any
}

interface UpdateData {
  user: UserData
  data: Record<string, any>
}

interface UsersFolder {
  $id?: string
  [key: string]: any
}

interface CmdbQueryResponse {
  children?: TableRow[]
  [key: string]: any
}

export default Vue.extend({
  name: 'USERS',

  components: {
    scrollArea,
    scrollTable,
    userCard,
    svgIcon
  },

  props: {},

  data(): {
    dialog: DialogState
    edit: boolean
    model: Record<string, any>
    options: OptionsData
    search: string
    sort: string
    table: TableData
  } {
    return {
      dialog: {
        open: false,
        addMode: false,
        data: null,
      },
      edit: false,
      model: {},
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      sort: '',
      table: {
        columns: [
          {
            title: 'user name',
            value: 'name',
            type: 'text',
            noTranslate: true,
            width: '25%',
          },
          {
            title: 'id',
            value: 'user_id',
            type: 'text',
            width: '15%'
          },
          {
            title: 'type_auth',
            value: 'type_auth',
            type: 'text',
            width: '20%'
          },
          {
            title: 'role',
            value: 'roles.role_nms',
            type: 'text',
            width: '20%'
          },
          {
            title: 'mail',
            value: 'notification.mail.mail',
            noTranslate: true,
            type: 'text',
            width: '20%'
          },
          {
            title: 'sms_phone',
            value: 'notification.sms.phone',
            type: 'text',
            width: '10%',
          }
        ],
        rows: [],
      },
    }
  },
  
  computed: {
    getData(): any {
      return this.data
    },

    getDialogData(): any | null {
      return this.dialog.data
    },

    getAddMode(): boolean {
      return this.dialog.addMode
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.id?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.type_auth?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.role?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.email?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.sms_phone?.toLowerCase().indexOf(searchLower) > -1
        })
      }

      if (this.sort) {
        const isDescending = this.sort.charAt(0) === '-'
        const fieldName = isDescending ? this.sort.slice(1) : this.sort
        const direction = isDescending ? -1 : 1
        t.rows = [...t.rows].sort(this.$compare(fieldName, direction))
      }

      return t
    },

    getOptions(): OptionsData {
      return this.options
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadUsers()
    },

    async loadUsers(): Promise<void> {
      console.log(this.$options.name, 'loadUsers', 'START')
      try {
        // const query = {
        //   id: ['/catalogs/user'],
        //   data: {
        //     namePath: true,
        //     children: {
        //       fields: [
        //         '$id', 'id', 'cls', 'blocked', 'comment', 'push_active',
        //         'config', 'email', 'name', 'maps', 'tags', 'role', 'sms_phone', 'type_auth'
        //       ],
        //       flatten: true,
        //     }
        //   }
        // }
        // const users = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]
        // const users = await this.$bridge.getAllUsers({"where":{"type_auth": "AD"}})
        const users = await this.$bridge.getAllUsers()
        // console.log(this.$options.name, 'loadUsers', 'json users', JSON.parse(JSON.stringify(users)))
        if (users?.length) {
          this.prepareTable(users)
        }
        // if (users?.[0]?.children) {
        //   this.prepareTable(users[0].children)
        // }
      } catch (error) {
        console.error(this.$options.name, 'loadUsers smth wrong', error)
      }
    },

    async prepareTable(users: TableRow[]): Promise<void> {
      if (!users?.length) return

      try {
        // console.log(this.$options.name, 'prepareTable', 'users', users)
        const users$ = users.map(user => {
          Object.keys(user).forEach(key => {
            if (!user[key]) {
              user[key] = ''
            }
          })
          return user
        })
        console.log(this.$options.name, 'prepareTable', 'users$', users$)
        if (users$.length) {
          this.table.rows = users$
        }
      } catch (error) {
        console.error(this.$options.name, 'prepareTable smth wrong', error)
      }
    },

    onAdd(): void {
      console.log(this.$options.name, 'onAdd')
      this.$set(this.dialog, 'addMode', true)
      this.$set(this.dialog, 'open', true)
    },

    onSelect(val: TableRow): void {
      console.log(this.$options.name, 'onSelect', 'val', val)
      if (val) {
        this.$set(this.dialog, 'data', val)
        this.$set(this.dialog, 'addMode', false)
        this.$set(this.dialog, 'open', true)
      }
    },

    onDialogClose(): void {
      console.log(this.$options.name, 'onDialogClose')
      this.$set(this.dialog, 'data', null)
      this.$set(this.dialog, 'addMode', false)
      this.$set(this.dialog, 'open', false)
    },

    async onUpdate(val: UpdateData): Promise<void> {
      console.log(this.$options.name, 'onUpdate', 'val', val)
      if (!val.user_id) return
      // if (!val.user?.user_id) return
      // if (!val.user?.$id) return

      try {
        let $data = val
        // let $data = {...val.user, ...val.data}
        // const user = await this.$bridge.getObjectById(val.user.$id)
        console.log(this.$options.name, 'onUpdate', '$data', $data)
        let user = await this.$bridge.editUser($data)

        if (user) {
          // console.log(this.$options.name, 'onUpdate', 'user', user)
          this.$dialog.notify.success(this.$getTranslate('update success'), { timeout: 5000 })
          this.setup()
        } else {
          this.$dialog.notify.success('Ошибка обновления', { timeout: 5000 })
          console.error('CATCH', 'USERS', 'onUpdate', 'smth wrong')
        }
      } catch (error) {
        this.$errorHandler(error)
        console.error(this.$options.name, 'onUpdate smth wrong', error)
      }
    },

    async onCreate(val: Record<string, any>): Promise<void> {
      try {
        if(!val) return
        if(val.name && !val.login) {
          val.login = val.name
        }
        console.log(this.$options.name, 'onCreate', 'val', val)
        let c = await this.$bridge.addUser(val)
        if (c) {
          this.setup()
          this.$dialog.notify.success('Новый пользователь успешно добавлен!', { timeout: 5000 })
        }

        // const usersFolder = await this.$bridge.getByPath('/catalogs/user') as UsersFolder
        // if (usersFolder?.$id) {
        //   const c = await usersFolder.createChild('systemuser', val)
        //   if (c) {
        //     this.setup()
        //     this.$dialog.notify.success('Новый пользователь успешно добавлен!', { timeout: 5000 })
        //   }
        // }
      } catch (error) {
        console.error(this.$options.name, 'onCreate smth wrong', error)
        this.$errorHandler(error)
      }
    },

    async onRemove(val: TableRow): Promise<void> {
      try {
        if (!val.user_id) return
        
        let obj = await this.$bridge.removeUsers([val.user_id])
        if (obj) {
          this.onDialogClose()
          this.setup()
          this.$dialog.notify.success('Пользователь удалён', { timeout: 5000 })

        }
      } catch (error) {
        console.error(this.$options.name, 'onRemove smth wrong', error)
        this.$errorHandler(error)
      }
    },

    sortTable(item: TableColumn): void {
      if (this.sort === item.value) {
        this.sort = '-' + item.value
      } else {
        this.sort = item.value
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
